import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import CustomButton from 'components/Button';

const Image = ({
  disabled,
  rounded,
  className,
  src,
  title,
  testid,
  alt,
  onClick,
  onError,
  addOverlay,
  icon,
  text,
}) => {
  const { t } = useTranslation();
  if (icon) {
    return (
      <CustomButton
        icon={icon}
        text={text}
        onClick={onClick}
        onError={onError}
        disabled={disabled}
        className={className}
      />
    );
  }
  return (
    <>
      <img
        className={cn(
          styles.default,
          { [styles.rounded]: rounded },
          { [styles.disabled]: disabled },
          className,
        )}
        data-cy={testid}
        title={t(title)}
        src={typeof src === 'object' ? src?.default : src}
        alt={alt}
        onClick={onClick}
        onError={onError}
      />
      {addOverlay && <div className={styles.overlay}></div>}
    </>
  );
};

Image.propTypes = {
  disabled: PropTypes.bool,
  addOverlay: PropTypes.bool,
  rounded: PropTypes.bool,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  alt: PropTypes.string,
  testid: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  icon: PropTypes.element,
  text: PropTypes.string,
};

Image.defaultProps = {
  rounded: false,
};

export default Image;
